"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class ModelService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getModelList(modelPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.get(`${this.baseUrl}application/module/admin/list?page=${modelPayload.pageNumber}&limit=${modelPayload.limit}`, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
    createModel(createPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.post(`${this.baseUrl}application/module/admin/create`, createPayload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    updateModel(updatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                updatePayload = JSONbig.stringify(updatePayload);
                const response = yield axios_1.default.patch(`${this.baseUrl}application/module/admin/edit`, updatePayload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    getModulesInApplication(fetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.get(`${this.baseUrl}application/admin/list_modules_in_application?application_id=${fetchPayload.application_id}&page=${fetchPayload.pageNumber}&limit=${fetchPayload.limit}`, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
}
exports.ModelService = ModelService;
